import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import ContinuousFrontier from "components/FrontierSliders/ContinuousFrontier";

import * as projectReducer from "containers/Project/reducer";

class ContinuousFrontierContainer extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    return <ContinuousFrontier {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {};
};

const mapStateToProps = (state, ownProps) => {
  return {
    frontiers: projectReducer.getContinuousFrontier(state, ownProps.id)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(ContinuousFrontierContainer);
